export default "/assets/images/mila-with-dimensions.f1802a778ec5af30.webp";